import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const FormStepsContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  margin-left: 55px; 
`;

export const FormStepsContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormStepsStatus = styled.div`
  display: flex;
  align-items: center;
  

  & + & {
    margin-top: 10px; 
  }
`;

export const FormStepsCircle = styled.div`
  min-width: 50px;
  min-height: 50px;
  border-radius: 25px;
  border: 2px solid ${prop => prop.finish ? colors.bgPrimaryLight : prop.active ? colors.bgPrimaryLight : colors.grayLight};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.finish ? colors.bgPrimaryLight: prop.active ? colors.white : colors.grayLight};
  color: ${prop => prop.active ? colors.bgPrimaryLight : colors.white};
  font-weight: 600;
`;

export const FormStepsStatusBar = styled.div`
  width: 178px;
  height: 2px;
  background: ${prop => prop.finish ? colors.bgPrimaryLight : colors.grayLight};
  margin-top: 8px;
`;

export const FormStepsLabel = styled.span`
  color: ${colors.textPrimary};
  margin-right: 0px;
  width: 130px;
`;
